module.exports = {
  AppName: "SSS"
};